import React from 'react';
import { Box } from '@fiverr-private/theme';
import { Typography } from '@fiverr-private/typography';
import { CalendarIcon } from '@fiverr-private/visuals';

interface CalendarTriggerProps {
  placeholder?: string;
  value: string;
}

export const CalendarTrigger: React.FC<CalendarTriggerProps> = ({ placeholder, value }: CalendarTriggerProps) => {
  const showPlaceHolder = !value && placeholder;

  return (
    <Box
      backgroundColor="white"
      width="100%"
      borderColor="grey_500"
      borderRadius="lg"
      borderWidth="sm"
      cursor="pointer"
      borderStyle="solid"
    >
      <Box
        cursor="pointer"
        color="inherit"
        boxSizing="borderBox"
        display="flex"
        justifyContent="spaceBetween"
        alignItems="center"
        userSelect="none"
        paddingY="2"
        paddingX="3"
        width="100%"
      >
        <Typography paddingRight="2" color={showPlaceHolder ? 'grey_900' : 'grey_1200'}>
          {showPlaceHolder ? placeholder : value}
        </Typography>
        <CalendarIcon color="grey_1200" />
      </Box>
    </Box>
  );
};
